import type { Customer } from '@brighterly/lib-core-types/customer/interfaces'
import type { ScopeTarget } from '@shared/lib/scope'

import { Discipline } from '@brighterly/lib-core-types/discipline/enums'

import { AppRoute } from '@shared/config'
import { resolveKidId } from '@shared/lib/routing'

interface ScopeRoute {
  path: string
  params: Record<string, unknown>
}

const KID_SUBJECT_PATH = /^\/kids\/\d+\/(math|ela)(\/|$)/

export const resolveScope = (route: ScopeRoute, customer: Customer | null): ScopeTarget | null => {
  const kidId = Number(route.params.kid)
  if (!Number.isFinite(kidId)) return null
  if (!customer?.kids?.some(kid => kid.id === kidId)) return null

  const segment = route.path.match(KID_SUBJECT_PATH)?.[1]
  const code = Object.values(Discipline).find(discipline => discipline.toLowerCase() === segment)
  if (!code) return null

  return { kidId, code }
}

export const getScopeHomePath = (target: ScopeTarget): string => {
  const home = target.code === Discipline.ELA ? AppRoute.HomeEla : AppRoute.HomeMath

  return resolveKidId(home, target.kidId) as string
}
